import React from 'react';
import './LongTermScheduleCalendar.scss';
import { Modal } from 'reactstrap';
import { getStatusChar } from './LtsJobCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon } from '@fortawesome/free-solid-svg-icons';

export default class LongTermScheduleKey extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showKey: false,
        };
    }

    toggleKeyModal = () => {
        const { showKey } = this.state;

        this.setState({ showKey: !showKey });
    };

    render() {
        const { showKey } = this.state;

        return (
            <>
                <button className="lts-key-btn" onClick={this.toggleKeyModal}>
                    Key
                </button>

                <Modal
                    toggle={this.toggleKeyModal}
                    isOpen={showKey}
                    fade={false}
                >
                    <div className="lts-modal">
                        <h3>Legend / Key</h3>
                        <div className="lts-key-section">
                            <h4>Status Indicators</h4>
                            <div className="lts-key-row">
                                <i>Restricted</i>
                            </div>
                            <div className="lts-key-row">
                                <span>{getStatusChar({})}</span>
                                <span>Draft</span>
                            </div>
                            <div className="lts-key-row">
                                <span>
                                    {getStatusChar({ isAssigned: true })}
                                </span>
                                <span>Assigned (not published)</span>
                            </div>
                            <div className="lts-key-row">
                                <span>
                                    {getStatusChar({ isPublished: true })}
                                </span>
                                <span>Published</span>
                            </div>
                            <div className="lts-key-row">
                                <span>
                                    {getStatusChar({ isReleased: true })}
                                </span>
                                <span>Released to Dispatch</span>
                            </div>
                            <div className="lts-key-row">
                                <span>
                                    {getStatusChar({ isCancelled: true })}
                                </span>
                                <span>Cancelled</span>
                            </div>
                        </div>
                        <div className="lts-key-section">
                            <h4>Shift</h4>
                            <div className="lts-key-row">
                                <span>
                                    <FontAwesomeIcon icon={faMoon} />
                                </span>
                                <span>Night Shift</span>
                            </div>
                        </div>
                        <div className="lts-key-section">
                            <h4>Crew Badge</h4>
                            <div className="lts-key-row">
                                <span className="lts-crew-badge">N</span>
                                <span>
                                    Total crews &minus; scheduled that day =
                                    remaining
                                </span>
                            </div>
                        </div>
                        <button
                            className="lts-modal-close-btn"
                            onClick={this.toggleKeyModal}
                        >
                            Close
                        </button>
                    </div>
                </Modal>
            </>
        );
    }
}
